import { render } from "./agenda.vue?vue&type=template&id=54cfe566&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=54cfe566&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54cfe566"

export default script